import GenericFilterRow from '../search/GenericFilterRow';

export interface PeopleFilters {
  yearFrom?: number;
  yearTo?: number;
  faculties: string[];
}

interface PeopleFilterRowProps {
  value: PeopleFilters;
  onChange: (next: PeopleFilters) => void;
  inert?: boolean;
}

export default function PeopleFilterRow({ value, onChange, inert = false }: PeopleFilterRowProps) {
  return (
    <GenericFilterRow<PeopleFilters>
      namespace="person"
      value={value}
      onChange={onChange}
      inert={inert}
    />
  );
}
